const zeroIfNullFn = (value) => {
  return value || 0
}

export default {
  zeroIfNull: zeroIfNullFn
}
